// PageDescription: 본인인증 가이드 화면
import { UserVerificationGuideView } from '@/views/user-verification-guide';

const UserVerificationGuidePage = () => {
  return <UserVerificationGuideView />;
};

export default UserVerificationGuidePage;
